import { Controller } from "@hotwired/stimulus";

/**
 * GR-3343: reveal the "what space, and what for" box when the requester ticks
 * "Additional Space Required".
 *
 * The box is required only while it is visible: a `required` attribute left on
 * a hidden field blocks submission with a validation bubble the requester
 * cannot see. Unticking also clears the text, matching the model callback that
 * discards the detail server-side, so the two cannot drift.
 */
export default class extends Controller {
  static targets = ["checkbox", "detail", "input"];

  toggle() {
    const checked = this.hasCheckboxTarget && this.checkboxTarget.checked;

    if (this.hasDetailTarget) {
      this.detailTarget.classList.toggle("d-none", !checked);
    }

    if (!this.hasInputTarget) return;

    this.inputTarget.required = checked;
    if (checked) {
      this.inputTarget.focus();
    } else {
      this.inputTarget.value = "";
    }
  }
}
